import React, { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import Image from "../Images/profile.jpg"
import { customerQueryReply } from "../services/Api";
import moment from "moment";

const HelpReply = () => {
    const [text, setText] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const query_id = location.state.query_id
    const queries = location.state.queries
    const user_id = location.state.user_id
    console.log(query_id)
    console.log(queries)
    console.log(user_id)
    // _id, user_id, answer, query_id

    const handleQueryReply = async (id) => {
        customerQueryReply(query_id, user_id, id, text)
            .then(res => {
                toast(res.data.message)
                setTimeout(() => {
                    navigate('/admin/userallquery')
                }, 5000)
            })
            .catch((err) => {
                toast(err.response.data.message)
                setTimeout(() => {
                }, 5000)
            });
    }
    return (
        <>
            < ToastContainer />
            <div className="flex flex-col bg-white space-y-6 px-5 sm:px-10 md:px-20 py-5">
                {/* Header */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <p className="text-xl font-semibold">Help and Support</p>
                    </div>
                </div>
                <button className="flex items-center w-fit bg-[#E53935] px-2 py-1 rounded-md active:scale-95 duration-500" onClick={() => navigate(-1)}>
                    <svg width="20" height="20" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5516 21.3393H30.2057C30.6543 21.3393 31.0304 21.1875 31.3339 20.8841C31.6373 20.5806 31.7891 20.2045 31.7891 19.7559C31.7891 19.3073 31.6373 18.9313 31.3339 18.6278C31.0304 18.3243 30.6543 18.1726 30.2057 18.1726H12.5516L17.0641 13.6601C17.3807 13.3434 17.5325 12.974 17.5193 12.5518C17.5061 12.1295 17.3543 11.7601 17.0641 11.4434C16.7474 11.1268 16.3714 10.9618 15.9359 10.9486C15.5005 10.9354 15.1245 11.0872 14.8078 11.4038L7.56406 18.6476C7.40573 18.8059 7.29358 18.9775 7.2276 19.1622C7.16163 19.3469 7.12865 19.5448 7.12865 19.7559C7.12865 19.967 7.16163 20.165 7.2276 20.3497C7.29358 20.5344 7.40573 20.7059 7.56406 20.8643L14.8078 28.108C15.1245 28.4247 15.5005 28.5764 15.9359 28.5632C16.3714 28.55 16.7474 28.3851 17.0641 28.0684C17.3543 27.7518 17.5061 27.3823 17.5193 26.9601C17.5325 26.5379 17.3807 26.1684 17.0641 25.8518L12.5516 21.3393Z" fill="white" />
                    </svg>
                    <button className="">
                        <span className=" text-white ms-1">Back</span>
                    </button>
                </button>
                <div className=" p-4 flex items-center justify-between">
                    <div className="flex space-x-3">
                        <img
                            src={queries.user?.profile_photo ? process.env.REACT_APP_API_URL + queries.user?.profile_photo : Image}
                            alt=""
                            width={40}
                            height={40}
                            className="rounded-full"
                        />
                        <div className="flex items-center ">
                            <div className="">
                                <p className="font-medium">{queries.message}</p>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <p className="text-sm text-gray-500"> {moment(queries.time).format('LT')} </p>
                    </div>
                </div>

                <div className=" p-4">
                    <div className="flex flex-col space-y-4">
                        <textarea
                            className="px-3 py-2 w-full h-24 rounded-md bg-[#F0F0F0] outline-none"
                            placeholder="Enter your text here..."
                            onChange={(e) => setText(e.target.value)}
                        />
                        <div className="flex items-center justify-between">
                            <div className="flex space-x-2">
                                {/* <button variant="ghost" size="icon" className="text-gray-500">
                                    <svg width="10" height="20" viewBox="0 0 13 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.2498 6.92123V19.2646C11.2498 21.7029 9.46484 23.8729 7.03817 24.1062C4.24984 24.3746 1.9165 22.1929 1.9165 19.4629V5.0429C1.9165 3.51456 3.01317 2.12623 4.52984 1.97456C6.27984 1.79956 7.74984 3.16456 7.74984 4.87956V17.1296C7.74984 17.7712 7.22484 18.2962 6.58317 18.2962C5.9415 18.2962 5.4165 17.7712 5.4165 17.1296V6.92123C5.4165 6.4429 5.01984 6.04623 4.5415 6.04623C4.06317 6.04623 3.6665 6.4429 3.6665 6.92123V16.9662C3.6665 18.4946 4.76317 19.8829 6.27984 20.0346C8.02984 20.2096 9.49984 18.8446 9.49984 17.1296V5.0779C9.49984 2.63956 7.71484 0.469565 5.28817 0.236232C2.5115 -0.0321018 0.166504 2.14957 0.166504 4.87956V19.1946C0.166504 22.5429 2.6165 25.5412 5.95317 25.8562C9.7915 26.2062 12.9998 23.2196 12.9998 19.4629V6.92123C12.9998 6.4429 12.6032 6.04623 12.1248 6.04623C11.6465 6.04623 11.2498 6.4429 11.2498 6.92123Z" fill="#909398" />
                                    </svg>

                                    <span className="sr-only">Attach file</span>
                                </button>
                                <button variant="ghost" size="icon" className="text-gray-500">
                                    <svg width="20" height="20" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_2032_9239)">
                                            <path d="M18.0835 12.8794C19.05 12.8794 19.8335 12.0959 19.8335 11.1294C19.8335 10.1629 19.05 9.37939 18.0835 9.37939C17.117 9.37939 16.3335 10.1629 16.3335 11.1294C16.3335 12.0959 17.117 12.8794 18.0835 12.8794Z" fill="#909398" />
                                            <path d="M9.9165 12.8794C10.883 12.8794 11.6665 12.0959 11.6665 11.1294C11.6665 10.1629 10.883 9.37939 9.9165 9.37939C8.95001 9.37939 8.1665 10.1629 8.1665 11.1294C8.1665 12.0959 8.95001 12.8794 9.9165 12.8794Z" fill="#909398" />
                                            <path d="M13.9885 2.37939C7.5485 2.37939 2.3335 7.60606 2.3335 14.0461C2.3335 20.4861 7.5485 25.7127 13.9885 25.7127C20.4402 25.7127 25.6668 20.4861 25.6668 14.0461C25.6668 7.60606 20.4402 2.37939 13.9885 2.37939ZM14.0002 23.3794C8.8435 23.3794 4.66683 19.2027 4.66683 14.0461C4.66683 8.88939 8.8435 4.71273 14.0002 4.71273C19.1568 4.71273 23.3335 8.88939 23.3335 14.0461C23.3335 19.2027 19.1568 23.3794 14.0002 23.3794ZM19.1452 16.2511C18.7368 15.9944 18.1885 16.1227 17.9435 16.5311C17.0802 17.8961 15.6102 18.7127 14.0002 18.7127C12.3902 18.7127 10.9202 17.8961 10.0568 16.5194C9.80016 16.1111 9.2635 15.9827 8.85516 16.2394C8.44683 16.4961 8.3185 17.0327 8.57516 17.4411C9.76516 19.3427 11.7835 20.4627 14.0002 20.4627C16.2168 20.4627 18.2352 19.3311 19.4252 17.4527C19.6818 17.0444 19.5535 16.5077 19.1452 16.2511Z" fill="#909398" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2032_9239">
                                                <rect width="28" height="28" fill="white" transform="translate(0 0.0461426)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span className="sr-only">Add emoji</span>
                                </button> */}
                            </div>
                            <button className="bg-red-500 hover:bg-red-600 text-white px-8 rounded-md active:scale-95 duration-500" onClick={() => handleQueryReply(queries._id)}>
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
export default HelpReply;